import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../utils/SectionProps';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Terms = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <title>MergeURL - Terms of Use</title>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 text-color-primary reveal-from-bottom center-content" data-reveal-delay="200">
              Terms of Use
            </h1>
            <div className="container-xs reveal-from-bottom" data-reveal-delay="200">
              <p className="center-content">Last updated: August 13, 2020</p>
              <p>By accessing the website at <a href="https://mergeurl.netlify.app"><span className="text-color-primary">https://mergeurl.netlify.app</span></a>
              , you are agreeing to be bound by these terms of use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. 
              If you do not agree with any of these terms, please do not use or access this site. The materials contained in this website are protected by applicable copyright and trademark law. 
              Please read these terms and conditions carefully before using Our Service.</p>

              <h2>Use License</h2>
              <p>Permission is granted to temporarily download one copy of the materials (information or software) on MergeURL's website for personal, non-commercial transitory viewing only. 
                This is the grant of a license, not a transfer of title, and under this license <strong>you may not:</strong></p>
              <li> modify or copy the materials and contents; </li>
              <li> display or use this service on their website or integrated to any other software for commercial or non-comercial purpose.</li>
              <li> attempt to decompile or reverse engineer any software contained on Our Site; </li>
              <li> remove any copyright or other proprietary notations from the materials;  or
                transfer the materials to another person or "mirror" the materials on any other server. </li>
              <p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by MergeURL at any time. 
                Upon terminating your viewing of these materials or upon the termination of this license, 
                you must destroy any downloaded materials in your possession whether in electronic or printed format and you might be liable to a fine.</p>

              <h2>Limitations</h2>
              <p>In no event shall MergeURL or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, 
                or due to business interruption) arising out of the use or inability to use the materials on MergeURL's website, 
                even if MergeURL or a MergeURL authorized representative has been notified orally or in writing of the possibility of such damage. 
                Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>
              <p>We are no guarantee for Our Service will always be live or available to use.</p>

              <h2>Accuracy of Materials</h2>
              <p>The materials appearing on MergeURL's website could include technical, typographical, or photographic errors. MergeURL does not warrant that any of the materials on its website are accurate, 
                complete or current. MergeURL may make changes to the materials contained on its website at any time without notice. However MergeURL does not make any commitment to update the materials.</p>
         
              <h2>Links to Other Websites</h2>
              <p>Our Service may contain links to third-party web sites or services that are not owned or controlled by the MergeURL.</p>
              <p>The MergeURL has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services.
                You further acknowledge and agree that the MergeURL shall not be responsible or liable, directly or indirectly, 
                for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content,
                goods or services available on or through any such web sites or services.</p>
              <p>Use of any such linked website is at the user's own risk. We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.</p>

              <h2>Changes to These Terms and Conditions</h2>
              <p>We reserve the right, at Our sole discretion, to modify or replace these Terms at any time without any notice. 
                By using this website you are agreeing to be bound by the then current version of these terms of use.</p>

              <h2>Disclaimer</h2>
              <p>Please move to our <a href="/disclaimer"><span className="text-color-primary">Disclaimer</span></a> page.</p>  
   
              <h2>Contact Us</h2>
              <p>If you have any questions about these Terms and Conditions, you can contact us:</p>
              <p>By email: <a href="mailto:support@mergeurl.com"><span className="text-color-primary">support@mergeurl.com</span></a></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

Terms.propTypes = propTypes;
Terms.defaultProps = defaultProps;

export default Terms;
